import React from 'react';
import BaseIcon from './BaseIcon';

class TrustWalletSVG extends BaseIcon {
  render() {
    const { fillColor, height, width } = this.props;
    return (
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 96 96"
        width={width}
        height={height}
      >
        <g>
          <path
            fill={fillColor}
            d="M48,96c-0.3,0-0.6-0.1-0.8-0.3c-5-3.4-9.4-5.9-13.4-8.1c-19.5-11.1-26-14.8-27-74.5c0-0.4,0.1-0.8,0.4-1.1
c0.3-0.3,0.7-0.4,1.1-0.4l0.9,0c6.3,0,23,0.1,37.9-11.4c0.5-0.4,1.3-0.4,1.8,0c14.9,11.5,31.6,11.4,37.9,11.4l0.9,0
c0.4,0,0.8,0.2,1.1,0.4c0.3,0.3,0.4,0.7,0.4,1.1c-1,59.7-7.5,63.4-27,74.4c-3.9,2.2-8.3,4.7-13.4,8.1C48.6,95.9,48.3,96,48,96z
 M9.8,14.7c1,56.5,6.8,59.8,25.4,70.4c3.7,2.1,7.9,4.5,12.7,7.6c4.8-3.1,9-5.5,12.7-7.7c18.7-10.6,24.5-13.9,25.5-70.3
c-6.9,0-23.3-0.2-38.2-11.3C33.1,14.4,16.3,14.7,9.8,14.7z"
          />
        </g>
      </svg>
    );
  }
}

export default TrustWalletSVG;
